import React from 'react';
import api from '../../../api';
import { IGetResidentGasDetaSetsParams, IGetResidentGasDetaSetsRes } from '@/types/api/bDevice/residentGasDataSets';

export const useFetchGasDataSets = (
  residentId: number,
  shouldInitFetch: boolean = false //初回fetchをするかどうか
) => {
  const [dataSets, setDataSets] = React.useState<IGetResidentGasDetaSetsRes[]>();

  const fetchGasDataSets = async (
    sort: IGetResidentGasDetaSetsParams['sort'] = 'desc',
    limit: IGetResidentGasDetaSetsParams['limit'] = 5000
  ) => {
    const params: IGetResidentGasDetaSetsParams = {
      residentId,
      sort,
      limit,
    };

    let result = await api.get('/b-devices/residents/:residentId/gas/data-sets', {
      params,
    });

    setDataSets(result);
    return result;
  };

  React.useEffect(() => {
    if (!shouldInitFetch || !residentId) return;
    fetchGasDataSets();
  }, []);

  return { gasDataSets: dataSets, fetchGasDataSets };
};
